module.exports = __webpack_public_path__ + "static/20-afcc490ae6575ecbde9a9ad45e1fe89e.jpg";